/**
 * WordPress dependencies
 */
import { useContext } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { NavigatorContext } from './context';

/**
 * Retrieves a `navigator` instance.
 */
function useNavigator() {
  const {
    location,
    goTo,
    goBack
  } = useContext(NavigatorContext);
  return {
    location,
    goTo,
    goBack
  };
}

export default useNavigator;
//# sourceMappingURL=use-navigator.js.map